import React, { useEffect, useMemo, useState } from 'react'
import UsagePatternChart from './UsagePatternChart'
import { Box, Typography } from '@mui/material'
import AppHealth from './AppHealth'
import { useSelector } from 'react-redux'
import { fetchNYUserFunnel } from '../../../api/nystats'

const usagePatternList = [
  { category: "0AM-4AM", count: 0,time:"Morning" },
  { category: "4AM-8AM", count: 0,time:"Morning" },
  { category: "8AM-12PM", count: 0,time:"Morning" },
  { category: "12PM-16PM", count: 0,time:"Afternoon" },
  { category: "16PM-20PM", count: 0,time:"Night" },
  { category: "20PM-0AM", count: 0,time:"Night" },
];

const UserUsagePattern = () => {
  const filter = useSelector((state) => state.filter);
  const filterWithoutUTM = useMemo(() => {
    const { utm_options, ...rest } = filter;
    return rest;
  }, [JSON.stringify(filter)]);
	  const [userPatterns, setUserPatterns] = useState(usagePatternList);
    const [versionDistribution,setVersionDistribution] = useState([])
	  const [isLoading, setIsLoading] = useState(false);

	const fetchData = async () => {
		try {
			setIsLoading(true);
			const data = await fetchNYUserFunnel(filter);
      const patternList = data?.userPatterns
      if(patternList){
        setUserPatterns(usagePatternList?.map(ele=>{return {...ele,count:patternList?.find(item=>item?._id===ele?.category)?.userCount ?? 0}}))
      }else{
        setUserPatterns([])
      }
      setVersionDistribution(data?.versionDistribution ?? [])
		} catch (err) {
      console.error("Error while loading New York User Usage Pattern data", err);
		} finally {
      setIsLoading(false);
		}
	};

	useEffect(() => {
		fetchData();
	}, [JSON.stringify(filterWithoutUTM)]);
  return (
	<Box sx={{ p: 2, borderRadius: 2, boxShadow:'none', border:'1px solid #E8E8E8', }}>
		 <Typography  sx={{
          fontSize: "18px",
          fontWeight: 500,
          color: "#101828",
          mb: 3,
          borderLeft: "3px solid #FBBF24",
          pl: 1,
        }}>
        User Funnel
      </Typography>
	  <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'stretch', gap:2}}>
        {
          isLoading || !userPatterns?.length ? <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="body1" color="text.secondary">
              {isLoading ? "Loading..." : "No data available"}
            </Typography>
          </Box> : <>
            <UsagePatternChart userPatterns={userPatterns} />
          </>}
	  {/* <AppHealth versionDistribution={versionDistribution}/> */}
	</Box>
	</Box>
  )
}

export default UserUsagePattern
